var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-container',[_c('AdminPageDataTable',{attrs:{"apiLink":_vm.apiLink,"apiSaveLink":_vm.apiSaveLink,"headers":_vm.headers,"slots":_vm.slots,"apiDeleteLink":_vm.apiDeleteLink},on:{"add":function($event){_vm.addDialog = true}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }